import React, { Component } from 'react';
import jwt_decode from "jwt-decode";
import instance from "./axios-instance";
import Swal from 'sweetalert2';
import Systems from "./SystemFunction";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { t } from './i18n';

class App extends Component {
    get lang() { return localStorage.getItem('lang') || 'th'; }
    constructor(props) {
        super(props);
        this.state = {
            mainsetting: [],
            rewardlist: [],
            logoimg: "",
            activePage: 1,
            pagecount: 1,
            products_page_count: 1,
            isActive: false,
            formData: {},
            errors: {},
            formSubmitted: false,
            loading: false,
            stateopterror: "",
            stateregis: 1,
            showpass: true,

            bankselect: 0,
            trueaccount: true,
            checkname: false,

            username: null,
            fname: "",
            checkboxacc: 0,
            userid: null,
            phoneNumber: "",
            password: "",
            passwordcf: "",
            accnumbertxt: "",
            lineid: "",
            refer: "ไม่ระบุ",

            userrecomend: "",
            linelink: "",
            balance: 0,
            mainacc: null,
            limit: {
                min: 0,
                max: 0
            }
        };

        this.forgetotpandregister = this.forgetotpandregister.bind(this);
    }

    notify = async (mode, msg) => {
        const type = String(mode || "").toLowerCase();

        const config = {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        };

        if (type === "success") {
            toast.success(msg, config);
        } else if (type === "warning") {
            toast.warning(msg, config);
        } else if (type === "error") {
            toast.error(msg, config);
        } else if (type === "info") {
            toast.info(msg, config);
        } else {
            toast(msg, config);
        }
    };

    modalerror = async (object) => {
        await this.notify(object.title, object.text);
    };

    radiocheck = (input) => {
        const bankId = Number(input);

        this.setState({
            bankselect: bankId
        });

        if (bankId === 99) {
            this.setState({
                trueaccount: false,
                checkname: false,
                fname: ""
            });
        } else {
            this.setState({
                trueaccount: true,
                checkname: false,
                fname: ""
            });
        }
    };

    forgetotpandregister = async (type) => {
        const {
            phoneNumber,
            otpphoneforget,
            bankselect,
            otpphone,
            accnumbertxt
        } = this.state;

        let recheck = false;

        try {
            if (type === 4) {
                const res = await instance.post("/api/v1/resetpassword", {
                    username: phoneNumber,
                    System: Systems,
                    type: type
                });
                recheck = res.data.message;
            } else if (type === 5) {
                const res = await instance.post("/api/v1/resetpassword", {
                    username: phoneNumber,
                    pin: otpphoneforget,
                    System: Systems,
                    type: type
                });
                recheck = res.data.message;
            } else if (type === 6) {
                const res = await instance.post("/api/v1/resetpassword", {
                    username: phoneNumber,
                    System: Systems,
                    type: type
                });
                recheck = res.data.message;
            } else if (type === 7) {
                const res = await instance.post("/api/v1/resetpassword", {
                    username: phoneNumber,
                    pin: otpphone,
                    System: Systems,
                    type: type
                });
                recheck = res.data.message;
            } else if (type === 10) {
                const res = await instance.post("/api/v1/resetpassword", {
                    accountnumber: accnumbertxt,
                    bankid: bankselect,
                    System: Systems,
                    type: type
                });
                recheck = res.data.message;
            }
        } catch (err) {
            console.log("[REGISTER:RESET_PASSWORD_ERROR]", err);
            recheck = false;
        }

        return recheck;
    };

    nextstep = async (e, num) => {
        if (e) e.preventDefault();

        const {
            password,
            passwordcf,
            bankselect,
            phoneNumber,
            fname,
            accnumbertxt
        } = this.state;

        if (num === 25) {
            if (!accnumbertxt) {
                await this.modalerror({
                    title: "error",
                    text: t(this.lang, 'u3_no_bank_account_no')
                });
                return;
            }

            if (accnumbertxt.length < 10) {
                await this.modalerror({
                    title: "error",
                    text: t(this.lang, 'u3_acc_no_invalid')
                });
                return;
            }

            if (!bankselect || Number(bankselect) === 0) {
                await this.modalerror({
                    title: "error",
                    text: t(this.lang, 'u3_no_bank_selected')
                });
                return;
            }

            this.setState({ loading: true });

            try {
                if (Number(bankselect) === 99) {
                    this.setState({
                        trueaccount: false,
                        checkname: false
                    });

                    if (!fname) {
                        await this.modalerror({
                            title: "warning",
                            text: t(this.lang, 'u3_enter_truewallet_name')
                        });
                        return;
                    }

                    await this.validatergisterForm(e, fname);
                    return;
                }

                if (!fname) {
                    const check = await this.forgetotpandregister(10);

                    if (check && check.checked) {
                        if (check.verifications && check.verifications.status === 0) {
                            this.setState({
                                trueaccount: false,
                                checkname: false
                            });

                            await this.modalerror({
                                title: "warning",
                                text: t(this.lang, 'u3_no_acc_name_found')
                            });
                            return;
                        }

                        if (check.verifications && check.verifications.status === 1) {
                            const accountName = check.verifications.name || "";

                            this.setState({
                                fname: accountName,
                                trueaccount: false,
                                checkname: true
                            });

                            await this.validatergisterForm(e, accountName);
                            return;
                        }
                    }

                    await this.modalerror({
                        title: "error",
                        text: t(this.lang, 'u3_acc_no_invalid_check')
                    });
                    return;
                }

                await this.validatergisterForm(e, fname);
            } finally {
                this.setState({ loading: false });
            }
        }
    };

    onChangex = (event) => {
        if (!event || !event.target) return;

        const { name, value } = event.target;

        if (name === "phoneNumber") {
            const onlyNumber = value.replace(/\D/g, "");
            this.setState({ [name]: onlyNumber });
            return;
        }

        if (name === "accnumbertxt") {
            const onlyNumber = value.replace(/\D/g, "");
            this.setState({ [name]: onlyNumber });
            return;
        }

        if (name === "bankselect") {
            this.radiocheck(value);
            return;
        }

        this.setState({ [name]: value });
    };

    validatergisterForm = async (e, fnameParam) => {
        if (e) e.preventDefault();

        const {
            phoneNumber,
            password,
            passwordcf,
            bankselect,
            accnumbertxt,
            lineid,
            refer
        } = this.state;

        const fname = fnameParam || this.state.fname;

        if (!phoneNumber || phoneNumber.length !== 10) {
            await this.modalerror({
                title: "error",
                text: t(this.lang, 'u3_enter_phone_10')
            });
            return;
        }

        if (!accnumbertxt) {
            await this.modalerror({
                title: "error",
                text: t(this.lang, 'u3_no_bank_account_no')
            });
            return;
        }

        if (!bankselect || Number(bankselect) === 0) {
            await this.modalerror({
                title: "error",
                text: t(this.lang, 'u3_no_bank_selected')
            });
            return;
        }

        if (!fname) {
            await this.modalerror({
                title: "error",
                text: t(this.lang, 'u3_no_name_lastname')
            });
            return;
        }

        if (!password) {
            await this.modalerror({
                title: "error",
                text: t(this.lang, 'u3_please_set_password')
            });
            return;
        }

        if (password.length > 15) {
            await this.modalerror({
                title: "error",
                text: t(this.lang, 'u3_pass_max15')
            });
            return;
        }

        if (password.length < 6) {
            await this.modalerror({
                title: "error",
                text: t(this.lang, 'u3_pass_min6')
            });
            return;
        }

        if (password !== passwordcf) {
            await this.modalerror({
                title: "error",
                text: t(this.lang, 'u3_pass_mismatch')
            });
            return;
        }

        this.setState({ loading: true });

        try {
            const res = await instance.post("/api/v1/register", {
                User_id: phoneNumber,
                name: fname,
                password: password,
                accbank: bankselect,
                accno: accnumbertxt,
                lineid: lineid || phoneNumber,
                refer: refer || "ไม่ระบุ",
                System: Systems,
                Useradvise: this.state.userrecomend
            });

            console.log("[REGISTER:RESPONSE]", res.data);

            if (res.data.status === 200) {
                await this.modalerror({
                    title: "success",
                    text: t(this.lang, 'u3_register_done_wait')
                });

                const loginRes = await instance.post("/api/v1/userlogin", {
                    userid: phoneNumber,
                    password: password,
                    System: Systems,
                    Function: 'validateLoginForm-navbar.js'
                });

                if (loginRes.data && loginRes.data.status === 200) {
                    localStorage.setItem('auth_token', loginRes.data.token);
                    setTimeout(() => {
                        window.location.href = '/';
                    }, 1500);
                    return;
                }

                await this.modalerror({
                    title: "error",
                    text: t(this.lang, 'u3_register_ok_autologin_fail')
                });
                return;
            }

            if (res.data.status === 203) {
                await this.modalerror({
                    title: "error",
                    text: t(this.lang, 'u3_acc_already_registered')
                });
                return;
            }

            if (res.data.status === 202) {
                await this.modalerror({
                    title: "error",
                    text: t(this.lang, 'u3_phone_already_registered')
                });
                return;
            }

            await this.modalerror({
                title: "error",
                text: t(this.lang, 'u3_username_or_name_invalid')
            });
        } catch (err) {
            console.log("[REGISTER:ERROR]", err);
            await this.modalerror({
                title: "error",
                text: t(this.lang, 'u3_register_fail_retry')
            });
        } finally {
            this.setState({ loading: false });
        }
    };

    changepass = (e) => {
        if (e) e.preventDefault();

        this.setState({
            showpass: !this.state.showpass
        });
    };

    saveclickaff = async (linkid) => {
        try {
            const res = await instance.post("/api/v1/saveclickaff", {
                linkid: linkid,
                System: Systems,
            });

            if (res.data.status === 200) {
                const date = new Date();
                const username = res.data.username;

                this.setState({
                    userrecomend: username,
                    link: linkid
                });

                localStorage.setItem('aff', JSON.stringify({ date, username }));
            }
        } catch (err) {
            console.log("[REGISTER:SAVE_CLICK_AFF_ERROR]", err);
        }
    };

    saveclick = async (linkid) => {
        try {
            const res = await instance.post("/api/v1/saveclickaff", {
                linkid: linkid,
                System: Systems,
            });

            if (res.data.status === 200) {
                const date = new Date();
                const username = res.data.username;

                this.setState({
                    userrecomend: username,
                });

                localStorage.setItem('aff', JSON.stringify({ date, username }));
            }
        } catch (err) {
            console.log("[REGISTER:SAVE_CLICK_ERROR]", err);
        }
    };

    async componentDidMount() {
        const search = window.location.href;

        const test = search.split("aff=")[1];
        if (test !== undefined) {
            this.saveclickaff(test.split("&")[0]);
        }

        const params = search.split("reg=")[1];
        if (params !== undefined) {
            this.saveclick(params);
            this.setState({
                userrecomend: params.split("&")[0],
            });
        }

        const tokenf = localStorage.getItem('aff');
        if (tokenf != null) {
            try {
                const codev = JSON.parse(tokenf);
                this.setState({
                    userrecomend: codev.username,
                });
            } catch (err) { }
        }

        const tokenx = localStorage.getItem('register');
        if (tokenx != null) {
            try {
                const codev = JSON.parse(tokenx);
                this.setState({
                    userrecomend: codev.username,
                });
            } catch (err) { }
        }

        try {
            const res = await instance.post("/api/v1/mainsetting", {
                System: Systems,
            });

            if (res.data.status === 200) {
                const datas = res.data.message;
                const min = res.data.tblcatagoryx[0].limitdeposit;
                const max = res.data.tblcatagoryx[0].maxdeposit;

                this.setState({
                    logoimg: res.data.tblsetting[0].imglogo,
                    linelink: datas[1].value,
                    System: res.data.tblcatagoryx[0].System,
                    limit: { min, max }
                });
            }
        } catch (err) {
            console.log("[REGISTER:MAINSETTING_ERROR]", err);
        }
    }

    render() {
        const {
            userrecomend,
            bankselect,
            phoneNumber,
            password,
            passwordcf,
            fname,
            accnumbertxt,
            lineid,
            refer,
            loading,
            trueaccount,
            checkname
        } = this.state;

        return (
            <>
                <ToastContainer />

                <div className="tt_l tt_full p_gl">
                    <div id="ct_from" className="tt_l tt_full title_page">
                        <h1>{t(this.lang, 'register')}</h1>
                    </div>

                    <div className="tt_l tt_full tt_content bg">
                        <div className="tt_l tt_full">
                            <div className="tt_l tt_full">
                                <div className="thaitheme_read"></div>

                                <div className="tt_l fr_login register_ft">
                                    <div className="fr_center">
                                        <div className="tt_l tt_full fr_h1">
                                            {t(this.lang, 'u3_register_intro')}
                                        </div>

                                        <form
                                            id="registerform"
                                            className="tt_l tt_full fr_re"
                                            onSubmit={(e) => this.nextstep(e, 25)}
                                        >
                                            <div className="tt_l tt_full fr_sec">
                                                <div className="tt_l fr_tx2x">
                                                    <i className="fa fa-phone" aria-hidden="true" />
                                                </div>
                                                <input
                                                    required
                                                    className="form-control tt_bk"
                                                    minLength={10}
                                                    maxLength={10}
                                                    name="phoneNumber"
                                                    type="text"
                                                    inputMode="numeric"
                                                    placeholder={t(this.lang, 'phone_number')}
                                                    size={10}
                                                    value={phoneNumber}
                                                    onChange={this.onChangex}
                                                />
                                            </div>

                                            <div className="tt_l tt_full fr_sec">
                                                <div className="tt_l tt_full fr_tx2x">
                                                    <i className="fa fa-key" aria-hidden="true" />
                                                </div>
                                                <input
                                                    id="pass"
                                                    required
                                                    className="form-control tt_bk"
                                                    name="password"
                                                    type={this.state.showpass ? "password" : "text"}
                                                    placeholder={t(this.lang, 'u3_set_password')}
                                                    value={password}
                                                    onChange={this.onChangex}
                                                />
                                            </div>

                                            <div className="tt_l tt_full fr_sec">
                                                <div className="tt_l tt_full fr_tx2x fr_txx">
                                                    {t(this.lang, 'confirm_password')}
                                                </div>
                                                <input
                                                    id="cm_pass"
                                                    required
                                                    className="form-control tt_bk fr_ixx"
                                                    name="passwordcf"
                                                    type={this.state.showpass ? "password" : "text"}
                                                    placeholder={t(this.lang, 'u3_confirm_password_again')}
                                                    value={passwordcf}
                                                    onChange={this.onChangex}
                                                />
                                            </div>

                                            <div className="tt_l tt_full fr_sec">
                                                <button
                                                    type="button"
                                                    onClick={this.changepass}
                                                    style={{
                                                        width: "100%",
                                                        border: "0",
                                                        padding: "8px",
                                                        cursor: "pointer",
                                                        background: "#222",
                                                        color: "#fff",
                                                        borderRadius: "4px"
                                                    }}
                                                >
                                                    {this.state.showpass ? t(this.lang, 'u3_show_password') : t(this.lang, 'u3_hide_password')}
                                                </button>
                                            </div>

                                            <div
                                                className="tt_l tt_full fr_sec"
                                                style={{
                                                    display: trueaccount && !checkname ? "none" : ""
                                                }}
                                            >
                                                <div className="tt_l tt_full fr_tx2x">
                                                    <i className="fa fa-user" aria-hidden="true" />
                                                </div>
                                                <input
                                                    required={!trueaccount || checkname}
                                                    className="form-control tt_bk"
                                                    id="name"
                                                    name="fname"
                                                    placeholder={t(this.lang, 'u3_name_lastname')}
                                                    value={fname}
                                                    onChange={this.onChangex}
                                                    readOnly={checkname}
                                                />
                                            </div>

                                            <div className="tt_l tt_full fr_sec_tx">
                                                {t(this.lang, 'u3_acc_name_must_match')}
                                            </div>

                                            <div className="tt_l tt_full fr_sec">
                                                <div className="tt_l tt_full fr_tx2x">
                                                    <i className="fa fa-university" aria-hidden="true" />
                                                </div>

                                                <select
                                                    required
                                                    className="fr_sc"
                                                    name="bankselect"
                                                    value={bankselect}
                                                    onChange={this.onChangex}
                                                >
                                                    <option value={0}>{t(this.lang, 'u3_select_bank')}</option>
                                                    <option value={6}>ธนาคาร กสิกรไทย จำกัด (มหาชน)</option>
                                                    <option value={7}>ธนาคาร กรุงเทพ จำกัด (มหาชน)</option>
                                                    <option value={14}>ธนาคาร กรุงไทย จำกัด (มหาชน)</option>
                                                    <option value={8}>ธนาคาร กรุงศรีอยุธยา จำกัด (มหาชน)</option>
                                                    <option value={9}>ธนาคาร เกียรตินาคิน จำกัด (มหาชน)</option>
                                                    <option value={11}>ธนาคาร ทหารไทยธนชาต จำกัด (มหาชน)</option>
                                                    <option value={10}>ธนาคาร ไทยพาณิชย์ จำกัด (มหาชน)</option>
                                                    <option value={18}>ธนาคาร ยูโอบี จำกัด (มหาชน)</option>
                                                    <option value={15}>ธนาคาร ออมสิน</option>
                                                    <option value={16}>ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร</option>
                                                    <option value={53}>ธนาคาร อาคารสงเคราะห์</option>
                                                    <option value={99}>ทรูวอลเลท</option>
                                                </select>
                                            </div>

                                            <div className="tt_l tt_full fr_sec">
                                                <div className="tt_l tt_full fr_tx2x">
                                                    <i className="fa fa-credit-card" aria-hidden="true" />
                                                </div>
                                                <input
                                                    className="form-control tt_bk"
                                                    required
                                                    id="account"
                                                    name="accnumbertxt"
                                                    type="text"
                                                    inputMode="numeric"
                                                    maxLength={18}
                                                    placeholder={t(this.lang, 'u3_your_bank_account_no')}
                                                    value={accnumbertxt}
                                                    onChange={this.onChangex}
                                                />
                                            </div>

                                            <div className="tt_l tt_full fr_sec">
                                                <div className="tt_l tt_full fr_tx2x">
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/fr-kine.jpg"
                                                        alt="line"
                                                    />
                                                </div>
                                                <input
                                                    className="form-control tt_bk"
                                                    id="lineid"
                                                    name="lineid"
                                                    type="text"
                                                    placeholder={t(this.lang, 'u3_line_id_or_phone')}
                                                    value={lineid}
                                                    onChange={this.onChangex}
                                                />
                                            </div>

                                            <div className="tt_l tt_full fr_sec">
                                                <div className="tt_l tt_full fr_tx2x">
                                                    <i className="fa fa-university" aria-hidden="true" />
                                                </div>
                                                <select
                                                    className="fr_sc"
                                                    required
                                                    name="refer"
                                                    value={refer}
                                                    onChange={this.onChangex}
                                                >
                                                    <option value="ไม่ระบุ">
                                                        {t(this.lang, 'u3_refer_channel')}
                                                    </option>
                                                    <option value="google">google</option>
                                                    <option value="facebook">facebook</option>
                                                    <option value="เว็บไซต์ติดแบนเนอร์">
                                                        {t(this.lang, 'u3_refer_banner')}
                                                    </option>
                                                    <option value="เพื่อนแนะนำ">{t(this.lang, 'u3_refer_friend')}</option>
                                                </select>
                                            </div>

                                            <div className="tt_l tt_full fr_sec_tx">
                                                {t(this.lang, 'u3_register_note')}
                                            </div>

                                            <button
                                                className="tt_l tt_ful fr_submit_bk"
                                                type="submit"
                                                disabled={loading}
                                                style={{
                                                    opacity: loading ? 0.7 : 1,
                                                    cursor: loading ? "not-allowed" : "pointer"
                                                }}
                                            >
                                                {loading ? t(this.lang, 'u3_registering') : t(this.lang, 'u3_confirm_register')}
                                            </button>

                                            <input
                                                type="hidden"
                                                className="affrom affck7"
                                                id="aff"
                                                name="aff"
                                                value={userrecomend || ""}
                                                readOnly
                                            />
                                            <input type="hidden" name="task" value="register" readOnly />
                                        </form>
                                    </div>
                                </div>

                                <div className="tt_l fr_repage">
                                    <div className="video_if">
                                        <video width="100%" height="auto" controls autoPlay>
                                            <source
                                                src="https://sv1.cdend.com/c2FnYW1lc2FnYW1lc2FnYW1lc2FnYW1lc2FnYW1lc2FnYW1l/สมัครสมาชิก_ufac4v2.mp4"
                                                title="YouTube video player"
                                            />
                                        </video>
                                    </div>

                                    <div className="tt_l tt_ful mt-10">
                                        <img
                                            src="https://s3.newworld.center/image/c66c0e37-8c81-47f8-8c3b-74308436e4f1.webp"
                                            alt="register banner"
                                        />
                                    </div>
                                </div>

                                <style
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            "\n.page-template-register .fr_login {padding-top: 0px;}\n.page-template-register .fr_center {width: 100%;}\n.video_if {\n\tposition: relative;\n\tpadding-bottom: 56.25%; \n\tpadding-top: 25px;\n\theight: 0;\n}\n.video_if iframe {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n}\n.fr_repage {\n    width: 43%;\n    padding: 30px 0px 0px 20px;\n    text-align: center;\n}\n.register_ft {\n    width: 55%;\n}\n@media screen and (max-width:800px){\n.fr_repage,\t\n.register_ft {width: 100%;}\t\n .page-template-register .fr_login {padding-bottom: 10px;}   \n.fr_repage {padding: 0px 0px 0px 0px;}\n}\t\n"
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default App;